<template>
  <div class="top-message-container" @click="$emit('msg-click')">
    <i class="iconfont icon-bpm-comments" />

    <sup v-show="count > 0" class="message-count">
      {{ count }}
    </sup>
  </div>
</template>

<script>
  export default {
    name: 'HtMessage',
    props: {
      messageCount: {
        type: [Number, String],
        default: '',
      },
    },
    computed: {
      //数量超过99时
      count() {
        return this.messageCount > 99 ? 99 : this.messageCount
      },
    },
  }
</script>

<style lang="scss" scoped>
  .top-message-container {
    position: relative;

    .message-count {
      position: absolute;
      top: 5px;
      right: 15px;
      display: inline-block;
      height: 18px;
      padding: 0 6px;
      font-size: 12px;
      line-height: 18px;
      color: #fff;
      text-align: center;
      white-space: nowrap;
      background-color: #f5603f;
      border: 1px solid #fff;
      border-radius: 10px;
      transform: translateY(-50%) translateX(100%);
    }

    .square-bg {
      width: 30px;
      border-radius: 10px 10px;
    }
  }
</style>
